export default "__VITE_ASSET__DkLVU1ba__"